import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { userStore, clubStore, courseStore } from '@/app/shared/stores';


const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    user: userStore,
    club: clubStore,
    course: courseStore,
  },
  plugins: [vuexLocal.plugin],
});

export { store };
